import React from "react";

import { AnimationOnScroll } from "react-animation-on-scroll";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import i18n from "../../i18n";

const PakVertScreen: React.FC = () => {
  const { t } = i18n;
  const langPrefix = getUrlLangPrefix();

  return (
    <Container
      fluid
      className="screenContainer p-0 pt-4 pt-lg-0"
      style={{ backgroundColor: "var(--screen-bg-color)" }}
    >
      <Container className="flexContainer pakvertContainer">
        <Row className="w-100 min-vh-15 pt-4 pb-4">
          <Col lg={6} xs={12}>
            <div className="flexContainer" style={{ gap: "8px" }}>
              <h2>{t("PakVert™ Panel Systems")}</h2>
              <p>
                {t(
                  "All-in-one exterior and interior wall panels for multi-storey buildings.",
                )}
              </p>
              <NavLink
                to={`${langPrefix}/${t("_route.multi-storey-buildings")}`}
              >
                <Button className="btn-primary">{t("Learn More")}</Button>
              </NavLink>
            </div>
          </Col>

          <Col lg={6} xs={12}>
            <div className="flexContainer mt-4 mt-lg-0">
              <AnimationOnScroll
                animateOnce
                animateIn="animate__fadeInRightBig"
                className="text-center"
              >
                <Image
                  rounded
                  alt={t("PakVert™ Panel Systems")}
                  className="mw-100 aspectImg aspectImg--16x9"
                  loading="lazy"
                  src="/images/home/Multi-Storey-Buildings_16x9.jpg"
                />
              </AnimationOnScroll>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default PakVertScreen;
